export function extractTitle(components: any[]) {
  const titleComponent = components.find((comp: any) => comp.id === 'title');
  return titleComponent?.content;
}
